export default function isValidEmail(value) {
    return value.includes('@') && value.includes('.');
}
